import { useNavigationGuardContext } from "@jugl-web/domain-resources/common/providers/NavigationGuardProvider";
import { MultiSectionLayout, TabsLayout } from "@jugl-web/ui-kit";
import {
  SideMenuList,
  SideMenuListItem,
  SideMenuPanel,
} from "@jugl-web/ui-kit/layout/SideMenuLayout";
import { useTranslations } from "@jugl-web/utils";
import { useScreenTransitionManager } from "@jugl-web/utils/utils/ScreenTransitionManager";
import React, { useEffect, useState } from "react";
import { useEmailAccount } from "../../../../providers/EmailAccountProvider/useEmailAccount";
import { ManageAccountsDrawerScreenToParametersMap } from "../../types";
import { EmailGeneralTab } from "./components/EmailGeneralTab";
import { EmailSettingsTab } from "./components/EmailSettingsTab";
import { ReactComponent as GeneralIcon } from "./assets/general.svg";
import { ReactComponent as SettingsIcon } from "./assets/settings.svg";
import { EmailAccountMenuTab } from "./types";

export const EmailAccountScreen: React.FC = () => {
  const { t } = useTranslations();
  const { isConnected } = useEmailAccount();
  const { requestNavigation } = useNavigationGuardContext();
  const { transitionTo } =
    useScreenTransitionManager<ManageAccountsDrawerScreenToParametersMap>();

  const [selectedMenuTab, setSelectedMenuTab] = useState<EmailAccountMenuTab>(
    EmailAccountMenuTab.general
  );

  useEffect(() => {
    if (!isConnected) {
      transitionTo({ name: "emailSetup" });
    }
  }, [isConnected, transitionTo]);

  if (!isConnected) {
    return null;
  }

  return (
    <TabsLayout
      selectedTab="account"
      tabs={[
        {
          id: "account",
          title: t({
            id: "client-support-page.account",
            defaultMessage: "Account",
          }),
        },
      ]}
    >
      <MultiSectionLayout
        classNames={{ content: "flex flex-col bg-grey-100" }}
        leftSide={
          <SideMenuPanel>
            <SideMenuList>
              <SideMenuListItem
                label={t({
                  id: "client-support-page.general",
                  defaultMessage: "General",
                })}
                startIcon={<GeneralIcon />}
                isSelected={selectedMenuTab === EmailAccountMenuTab.general}
                onClick={() =>
                  requestNavigation(() =>
                    setSelectedMenuTab(EmailAccountMenuTab.general)
                  )
                }
              />
              <SideMenuListItem
                label={t({
                  id: "client-support-page.settings",
                  defaultMessage: "Settings",
                })}
                startIcon={<SettingsIcon />}
                isSelected={selectedMenuTab === EmailAccountMenuTab.settings}
                onClick={() => setSelectedMenuTab(EmailAccountMenuTab.settings)}
              />
            </SideMenuList>
          </SideMenuPanel>
        }
      >
        {selectedMenuTab === EmailAccountMenuTab.general ? (
          <EmailGeneralTab />
        ) : (
          <EmailSettingsTab />
        )}
      </MultiSectionLayout>
    </TabsLayout>
  );
};
